import { useGraphileFiltersUrlQuery } from "components/Shared/FilterEditor/urlQuerySerializers";
import {
  BrandOrderingPlatformFilter,
  OrderingPlatformType,
} from "__generated__/gql/graphql";
import { AppliedFilter } from "components/Shared/FilterEditor/utils";
import FilterBarWithSearch from "components/Shared/FilterEditor/FilterBar/FilterBarWithSearch";
import CustomerPresenceTable, { Props as TableProps } from "./Table";
import filterDefinitions from "./filterDefinitions";
import ExportCustomerProductPresenceButton from "./Export";

const DEFAULT_FILTERS: AppliedFilter[] = [
  { filter: "sku__isArchived", variant: "equalTo", value: false },
  {
    filter: "brandOrderingPlatform__orderingPlatform__orderingPlatformType",
    variant: "in",
    value: [OrderingPlatformType.NATL_DIST],
  },
];

type Props = TableProps;

export default function CustomerPresenceTableView({
  filter: filterProp,
  ...rest
}: Props) {
  const { filter, filters, isTableReady, handleFiltersChange } =
    useGraphileFiltersUrlQuery<BrandOrderingPlatformFilter>(filterDefinitions, {
      defaultFilters: DEFAULT_FILTERS,
    });

  return (
    <>
      <FilterBarWithSearch
        key={String(isTableReady)}
        filterDefinitions={filterDefinitions}
        filters={filters}
        onFiltersChange={handleFiltersChange}
        headerRight={
          <ExportCustomerProductPresenceButton
            filter={filter}
            isDisabled={!isTableReady}
          />
        }
      />
      <CustomerPresenceTable {...rest} filter={filter} isReady={isTableReady} />
    </>
  );
}
